import { makeStyles } from "@material-ui/core";
import { ResponsiveLine } from "@nivo/line";
import { DashboardHeader } from "pages/admin/dashboard/components/general";
import { useEffect, useState } from "react";
const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: "100%",
    height: "calc(100% - 35px)",
  },
  chart: {
    width: "100%",
    height: "100%",
  },
}));

const basedata = [
  {
    id: "month",
    color: "#BEE0E9",
    data: [
      {
        x: "Jan",
        y: 0,
      },
      {
        x: "Feb",
        y: 0,
      },
      {
        x: "Mar",
        y: 0,
      },
      {
        x: "Apr",
        y: 0,
      },
      {
        x: "May",
        y: 0,
      },
      {
        x: "June",
        y: 0,
      },
      {
        x: "Jul",
        y: 0,
      },
      {
        x: "Aug",
        y: 0,
      },
      {
        x: "Sep",
        y: 0,
      },
      {
        x: "Oct",
        y: 0,
      },
      {
        x: "Nov",
        y: 0,
      },
      {
        x: "Dec",
        y: 0,
      },
    ],
  },
];

function ResponsiveLineEndorsement({ data }) {
  const [localData, setLocalData] = useState(data);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  return (
    <ResponsiveLine
      data={localData}
      margin={{ top: 30, right: 10, bottom: 30, left: 30 }}
      animate={true}
      isInteractive={false}
      axisTop={null}
      axisRight={null}
      axisLeft={null}
      enableArea={true}
      enableGridX={false}
      enableGridY={false}
      enablePointLabel={true}
      colors={data?.map((x) => x.color)}
    />
  );
}

function Endorsement(props) {
  const classes = useStyles();
  const _data = props.data;
  const _baseData = basedata[0].data;
  if (_data) {
    _baseData.forEach((b, index) => {
      b.y = _data[index].count;
    });
  }
  // const [localData, setLocalData] = useState(basedata[0].data)

  // useEffect(() => {
  //   const _baseData = basedata[0].data;
  //   if (_data) {
  //     _baseData.forEach((b, index) => {
  //       b.y = _data[index].count;
  //     })
  //   }
  //   setLocalData(_baseData);
  // }, [props])

  return (
    <>
      <div>
        <DashboardHeader
          title="Result of qualification endorsement"
          onSelectViewAll={() => {
            props.onSelectViewAll();
          }}
        />
      </div>
      <div className={classes.wrapChart}>
        <ResponsiveLineEndorsement data={basedata} className={classes.chart} />
      </div>
    </>
  );
}

export default Endorsement;
